export default {
  GET_PARTICIPATIONS_WINNERS_REQUEST: '@@participations_winners/GET_PARTICIPATIONS_WINNERS_REQUEST',
  GET_PARTICIPATIONS_WINNERS_SUCCESS: '@@participations_winners/GET_PARTICIPATIONS_WINNERS_SUCCESS',
  GET_PARTICIPATIONS_WINNERS_ERROR: '@@participations_winners/GET_PARTICIPATIONS_WINNERS_ERROR',

  CLEAR_PARTICIPATIONS_WINNERS: '@@participations_winners/CLEAR_PARTICIPATIONS_WINNERS',
};
